import { Section } from "./Section";
import { Reveal } from "./Reveal";
import { LeadDialog } from "./LeadDialog";
import { Button } from "../ui/button";
import { INVESTOR_POINTS } from "../../config/site";
import { TrendingUp } from "lucide-react";

export const Investors = () => (
  <Section
    id="investors"
    dark
    overline="For investors"
    title="Enter early on an approved corridor."
    sub="Industrial land rewards early entry. BIDC is Phase 1 pricing on a Govt.-approved corridor."
  >
    <div className="grid gap-4 sm:grid-cols-2">
      {INVESTOR_POINTS.map((p, i) => (
        <Reveal key={p.title} delay={i * 0.07}>
          <div className="h-full border border-paper/15 bg-forest-light/40 p-6" data-testid={`investor-point-${i}`}>
            <TrendingUp className="h-6 w-6 text-gold" strokeWidth={1.5} />
            <h3 className="mt-4 font-display text-xl font-medium text-paper">{p.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-paper/65">{p.desc}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.15}>
      <div className="mt-10 flex flex-wrap items-center justify-between gap-5 border border-gold/40 bg-forest-dark/60 px-6 py-6">
        <div>
          <p className="font-display text-2xl font-medium text-paper">Limited inventory. ~40% already gone.</p>
          <p className="mt-1 text-xs text-paper/50">
            *Past price trends are no guarantee of future returns. Invest after your own due diligence.
          </p>
        </div>
        <LeadDialog type="site_visit" defaults={{ message: "Investor enquiry" }}>
          <Button
            className="bg-gold text-forest-dark hover:bg-paper hover:text-forest transition-colors duration-200"
            data-testid="investor-enquire-button"
          >
            Talk to our team
          </Button>
        </LeadDialog>
      </div>
    </Reveal>
  </Section>
);
